import { render } from "./EditPageThumbnail.vue?vue&type=template&id=3284908e&scoped=true"
import script from "./EditPageThumbnail.vue?vue&type=script&lang=js"
export * from "./EditPageThumbnail.vue?vue&type=script&lang=js"

import "../../assets/scss/edit_page_thumbnail.scss?vue&type=style&index=0&id=3284908e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3284908e"]])

export default __exports__